import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hook.ts'
import { colors } from '../../../../ui/colors.ts'
import { BrightyIcon } from '../../../../ui/icons/brightyIcon.tsx'
import { setTextMessage } from './slice.ts'

interface Props {
    title: string
    question: string
    onClick?: () => void
}

export function BrightyCard(props: Props) {
    const dispatch = useAppDispatch()

    const brightyState = useAppSelector(state => state.brighty)

    return (
        <div onClick={() => {
            if (!brightyState.written) {
                dispatch(setTextMessage(props.question))
                const input = document.querySelector('input')
                if(input) input.focus()
            }
        }} className=' cursor-pointer w-[50%] flex flex-col rounded-2xl p-6 gap-2 border border-neutral-200 bg-gradient-to-b from-gray-50 to-white hover:bg-none hover:bg-gray-50'>
            <div className=' gap-2 flex'>
                <BrightyIcon size='20' color={colors.brandPrimary[500]} />
                <span className=' text-text-md font-bold text-brandSecondary-800'>{props.title}</span>
            </div>
            <span className=' text-text-sm text-brandSecondary-600'>{props.question}</span>
        </div>
    )
}
